<template>
    <div class="LocationNav">
        <a class="nav-item" v-if="byggnadsinfo" href="#byggnadsinfo" @click.prevent="scrollToElement('byggnadsinfo')">
            <div><i class="fas fa-building" /> Byggnadsinformation</div>
            <i class="fas fa-chevron-right" />
        </a>
        <a class="nav-item" v-if="relatedArticles" href="#relatedArticles" @click.prevent="scrollToElement('relatedArticles')">
            <div><i class="fas fa-file-alt" /> Artiklar</div>
            <i class="fas fa-chevron-right" />
        </a>
        <a class="nav-item" v-if="related" href="#related" @click.prevent="scrollToElement('related')">
            <div><i class="fas fa-file-image" /> Bilder, filmer, ljud och dokument</div>
            <i class="fas fa-chevron-right" />
        </a>
        <a class="nav-item" v-if="relatedLinks" href="#related" @click.prevent="scrollToElement('relatedLinks')">
            <div><i class="fas fa-link" /> Länkar</div>
            <i class="fas fa-chevron-right" />
        </a>
    </div>
</template>

<script>
export default {
  props: ['location'],
  data: () => ({
    byggnadsinfo: null,
    relatedArticles: null,
    related: null,
    relatedLinks: null
  }),

  mounted () {
    this.byggnadsinfo = document.getElementById('byggnadsinfo')
    this.relatedArticles = document.getElementById('relatedArticles')
    this.related = document.querySelector('.related:not(#relatedArticles)')
    this.relatedLinks = document.getElementById('relatedLinks')
  },

  methods: {
    scrollToElement: function (id) {
      this.$scrollTo(`#${id}`, 1000, {
        easing: 'ease-in-out',
        lazy: false
      })
    }
  },

  computed: {
    hasRelated: () => {
      return true
    }
  }
}
</script>
